import { render, staticRenderFns } from "./Cenik.vue?vue&type=template&id=5bbcce59&"
import script from "./Cenik.vue?vue&type=script&lang=js&"
export * from "./Cenik.vue?vue&type=script&lang=js&"
import style0 from "./Cenik.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports